import React, { useEffect, useState } from "react"
import { Box, Button, Grid, Typography } from "@mui/material"
import * as Style from "./style"
import moment from "moment"
import { CiMail } from "react-icons/ci"
import { LuPhone } from "react-icons/lu"
import { FaPencilAlt } from "react-icons/fa"
import { FaFileInvoice } from "react-icons/fa6"
import { LuLock } from "react-icons/lu"
import { Link } from "react-router-dom"
import { useGetProfileQuery } from "../../features/Auth/authApi"
import dummy from "../../images/dummy-icon.png"
import ChangePasswordModal from "./ChangePasswordModal"
import CenteredSpinner from "../common/CenteredSpinner"
import EditAccount from "./EditAccount"
import { setuserProfile } from "../../features/Auth/authSlice"
import { useAppDispatch } from "../../app/hooks"

const MyAccount = () => {
  const { data: getProfile, isFetching, isLoading } = useGetProfileQuery({})
  const [open, setOpen] = React.useState(false)
  const [editSave, setEditSave] = useState(true)
  const dispatch = useAppDispatch()

    const [liveProfile, setLiveProfile] = useState({
      profilePic: '', 
      name: '', 
      email: '',
      contactNo: '',
    })
  
    useEffect(() => {
      if (getProfile?.data){
          dispatch(setuserProfile(getProfile?.data))
        setLiveProfile({
          profilePic: getProfile.data.profilePic || dummy,
          name: getProfile.data?.name || "--",
          email: getProfile.data?.email || "--",
          contactNo: getProfile.data?.contactNo || "--"
        })
      }
    }, [getProfile])
    
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Style.Overview>
        {isLoading ? (
          <CenteredSpinner />
        ) : (
          <Grid container>
            <Grid xs={12} md={5} lg={4} className="pe-0 pe-xl-4">
              <Box className="review-card text-center p-4 d-flex flex-column align-items-center h-100">
                <Box className="mb-4">
                  <img
                    src={liveProfile?.profilePic || dummy}
                    className="profile-img-2"
                  />
                </Box>
                <Typography variant="body1" align="center" className="mb-3">
                  {liveProfile?.name || ""}
                </Typography>
                <Typography
                  variant="body1"
                  align="center"
                  className="mb-3 d-flex gap-2 align-items-center"
                >
                  <CiMail /> {liveProfile?.email || ""}
                </Typography>
                <Typography variant="body1" align="center" className="mb-3">
                  <LuPhone /> {liveProfile?.contactNo || ""}
                </Typography>
                <Link to={"/dashboard/Invoice"} className="view-profile mb-3">
                  My Invoice{" "}
                  <FaFileInvoice style={{ verticalAlign: "baseline" }} />
                </Link>
                <Link
                  to=""
                  onClick={() => setEditSave(!editSave)}
                  className="view-profile mb-3"
                >
                  {editSave ? (
                    <>
                  Edit <FaPencilAlt style={{ verticalAlign: "baseline" }} />
                  </>) : (
                    "Cancel"
                  )
                  }
                </Link>
                <Button
                  onClick={() => setOpen(true)}
                  className="view-profile mb-3 "
                  style={{ textTransform: "capitalize" }}
                >
                  Change Password{" "}
                  <span className="">
                    {" "}
                    <LuLock style={{ verticalAlign: "baseline" }} />
                  </span>
                </Button>
              </Box>
            </Grid>

            <Grid xs={12} md={7} lg={8} className=" ps-xl-4 mt-2 mt-md-0">
              {editSave ? (
                <Box className="review-card p-4 h-100">
                  <Grid container className="mb-4">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1">
                        <strong> Name </strong>
                      </Typography>
                    </Grid>
                    <Grid xs={8}>
                      <Typography variant="body1" className=" ">
                        {getProfile?.data?.name || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-4">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1">
                        <strong> E-Mail </strong>
                      </Typography>
                    </Grid>
                    <Grid xs={8}>
                      <Typography variant="body1" className=" ">
                        {getProfile?.data?.email || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-4">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1">
                        <strong> Phone Number </strong>
                      </Typography>
                    </Grid>
                    <Grid xs={8}>
                      <Typography variant="body1" className=" ">
                        {getProfile?.data?.contactNo || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-4">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1">
                        <strong> Gender </strong>
                      </Typography>
                    </Grid>
                    <Grid xs={8}>
                      <Typography variant="body1" className=" ">
                        {getProfile?.data?.gender || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-4">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1">
                        <strong>Language </strong>
                      </Typography>
                    </Grid>
                    <Grid xs={8}>
                      <Typography variant="body1" className="overflow-anywhere">
                        {getProfile?.data?.language?.join(", ") || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-4">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1">
                        <strong> Date Of Birth </strong>
                      </Typography>
                    </Grid>
                    <Grid xs={8}>
                      <Typography variant="body1" className=" ">
                        {getProfile?.data?.dob ? (
                          <>
                            {moment(getProfile?.data?.dob).format("YYYY-MM-DD")}
                          </>
                        ) : (
                          "--"
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-4">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1">
                        {" "}
                        <strong> Location </strong>
                      </Typography>
                    </Grid>
                    <Grid xs={8}>
                      <Typography variant="body1" className=" ">
                        {getProfile?.data?.address?.location || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                <EditAccount 
                setEditSave={setEditSave} 
                editSave={editSave}
                updateLiveProfile={setLiveProfile}
                currentProfile={liveProfile} />
              )}
            </Grid>
          </Grid>
        )}
      </Style.Overview>
      <ChangePasswordModal opens={open} handleClose={handleClose} />
    </>
  )
}
export default MyAccount
